import React from 'react';

export const ValueContext = React.createContext();
